import Spinner from 'src/javascripts/components/utilities/Spinner'

export default class ExportsTemplatesColumnsEdit {

  constructor() {}

  render() {

    // Reload page when table name changes to update column options
    // Include selected table_name= in URL params
    $('#exports_template_column_table_name').on('change', (e) => {
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      let displayName = $('#exports_template_column_display_name').val();
      let selectedTable = e.target.value;
      let url = new URL(window.location.href);
      url.searchParams.set('table_name', selectedTable);
      url.searchParams.set('display_name', displayName);
      this._preserveFilterParams(url);
      Turbo.visit(url.toString());
    });

    // Reload page when column name changes to update display option default
    $('#exports_template_column_column_name').on('change', (e) => {
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      let existingDisplayName = $('#exports_template_column_display_name').val();
      let displayName = existingDisplayName.trim() || $(e.target).find('option:selected').text();
      let tableName = $('#exports_template_column_table_name').val();
      let selectedColumn = e.target.value;
      let url = new URL(window.location.href);
      url.searchParams.set('table_name', tableName);
      url.searchParams.set('display_name', displayName);
      url.searchParams.set('column_name', selectedColumn);
      this._preserveFilterParams(url);
      Turbo.visit(url.toString());
    });

    // Reload page when formatting changes so formula input is shown/hidden
    $('#exports_template_column_formatting').on('change', (e) => {
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      let url = new URL(window.location.href);
      url.searchParams.set('formatting', e.target.value);
      this._preserveFilterParams(url);
      Turbo.visit(url.toString());
    });

    // Change destroy to false when edit a typeahead filter
    $('.export-template-filter').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      const inputGroup = ev.target.closest('.input-group');
      const destroyField = inputGroup.querySelector('input[name*="_destroy"]');
      if (destroyField) {
        destroyField.value = '0';
      }
    });

    // Change destroy based on value when a select filter changes
    $(document).on('change', '.js-select-filter', function() {
      const group = this.closest('.export-filter-group');
      const destroyField = group?.querySelector('input[name*="_destroy"]');
      if (destroyField) {
        destroyField.value = this.value ? '0' : '1';
      }
    });

    // Change destroy to true when clear typeahead clicked
    $('.clear-export-filter-typeahead').on('click', (e) => {
      const inputGroup = $(e.target).closest(".input-group");
      const destroyField = inputGroup.find('input[name*="_destroy"]')[0];
      const inputField = inputGroup.find(".twitter-typeahead input");
      if (destroyField) {
        destroyField.value = '1';
      }
      if (inputField) {
        inputField.typeahead("val", "");
      }

    });

    // Multi-select collection type checkboxes
    this.initCollectionTypeCheckboxes();
  }

  _preserveFilterParams(url) {
    const metricId = document.getElementById('exports_template_column_metric_id');
    if (metricId?.value) url.searchParams.set('metric_id', metricId.value);
  }

  initCollectionTypeCheckboxes() {
    document.querySelectorAll('.js-collection-type-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.syncCollectionTypeValue());
    });
    this.syncCollectionTypeValue();
  }

  syncCollectionTypeValue() {
    const checkboxes = document.querySelectorAll('.js-collection-type-checkbox');
    if (!checkboxes.length) return;

    const target = document.querySelector(checkboxes[0].dataset.target);
    if (!target) return;

    const destroySelector = checkboxes[0].dataset.destroySelector;
    const destroyField = destroySelector ? document.querySelector(destroySelector) : null;

    const selected = Array.from(checkboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    target.value = selected.join(',');

    if (destroyField) {
      destroyField.value = selected.length > 0 ? '0' : '1';
    }
  }

}
